module.exports = __webpack_public_path__ + "img/joinUs_block2.78111490.png";